module.exports = __webpack_public_path__ + "img/4d70a297-1b24-4f47-913e-60f3ab9e4598-1.4d80b146.jpg";